// src/redux/slices/tmmLinkSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface dataUrl {
  URL: string;
}

interface TmmLinkState {
  data: dataUrl;
  loading: boolean;
  error: string | null;
  status: number | null;
  resetFiltersInexport:boolean;
}
const initialState: TmmLinkState = {
  data: {
    URL: "",
  },
  loading: false,
  error: null,
  status: null,
  resetFiltersInexport:false
};
var BASE_URL = process.env.REACT_APP_BASE_URL;
export const fetchTmmLink = createAsyncThunk(
  "fetchTmmLink",
  async (env: any, { rejectWithValue }) => {
    try {
      // const env = process.env.REACT_APP_ENV;
      const response = await axios.post(
        `${BASE_URL}/tmmExport/fetchTmmExportLink`,
        { env }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Error fetching TMM link");
    }
  }
);

const tmmLinkSlice = createSlice({
  name: "fetchTmmLink",
  initialState,
  reducers: {
    setresetFiltersInexport:(state,action)=>{
      state.resetFiltersInexport=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTmmLink.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTmmLink.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.status = 200;
        console.log(action.payload, "action.payload from tmm");
      })
      .addCase(fetchTmmLink.rejected, (state, action) => {
        state.loading = false;

        const payload = action.payload as { status: number; message: string };

        state.status = payload?.status || 500;
        state.error = payload?.message || "Failed to fetch TMM link";
        state.data = { URL: "" };
      });
  },
});
export const {setresetFiltersInexport}=tmmLinkSlice.actions;
export default tmmLinkSlice.reducer;
